import { Formik } from "formik";
import { useReducer } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import FormDisplay from "./FormDisplay";
import pages from "../../../constants/pages";
import { useAxios, useAlert } from "../../../hooks";
import { objectFromFormData, schema } from "./audienceObjects";

export default function Form({
  fields,
  formData,
  component,
  editState,
  setEditState,
  categories,
  setFields,
}) {
  const axios = useAxios();
  var intialValue = formData;

  const { alert } = useAlert();
  const navigate = useNavigate();
  const dispatchUpdate = useDispatch();

  const memberDetails = useSelector((state) => state.memberDetails);
  const [state, dispatch] = useReducer(formReducer, intialValue);

  return (
    <Formik
      enableReinitialize
      initialValues={state}
      validateOnMount
      validationSchema={schema(fields)}
      onSubmit={(formData, { setSubmitting }) => {
        let url = "/brand/audience";
        let method = "POST";

        if (!!formData.ID) {
          url = "/brand/audience/" + formData.ID;
          method = "PUT";
        }

        axios({
          url: url,
          method: method,
          disableRedirect: true,
          data: objectFromFormData(state, memberDetails),
        })
          .then((res) => {
            if (res.status) {
              if (!!formData.ID) {
                setEditState(false);
                dispatchUpdate(
                  alert({
                    message: "Audience updated successfully!",
                    type: "success",
                  })
                );
              } else {
                dispatchUpdate(
                  alert({
                    message: "Audience created successfully!",
                    type: "success",
                  })
                );
                navigate(pages.myCampaign.route);
              }

              setSubmitting(false);
            }
          })
          .catch((err) => {
            console.error(err);
          });
      }}
    >
      {(formikProps) => (
        <FormDisplay
          setFields={setFields}
          categories={categories}
          state={state}
          dispatch={dispatch}
          fields={fields}
          component={component}
          formikProps={formikProps}
          editState={editState}
          setEditState={setEditState}
        />
      )}
    </Formik>
  );
}

const formReducer = (state, action) => {
  switch (action.type) {
    case "UPDATE_FIELD":
      var options = { ...state };
      if (action?.payload.value === undefined || action?.payload.value === "") {
        delete options[action?.payload.name];
        return {
          ...options,
        };
      }

      return {
        ...state,
        [action.payload.name]: {
          ...state[action?.payload?.name],
          [action.payload.key]: action.payload.value,
        },
      };

    case "MULTI_DROP_DOWN":
      var option = { ...state };
      if (!action?.payload?.hasOwnProperty("value")) {
        delete option[action?.payload.name];
        return {
          ...option,
        };
      }
      if (action?.payload.value === undefined) {
        return {
          ...option,
        };
      }

      if (action.payload?.value?.length === 0) {
        delete option[action?.payload.name];
        return {
          ...option,
        };
      } else {
        return {
          ...state,
          [action.payload.name]: {
            ...state[action?.payload?.name],
            [action.payload.key]: action.payload.value,
          },
        };
      }

    case "DATE_UPDATE_FIELD":
      return {
        ...state,
        [action.payload.name]: {
          ...state[action?.payload?.name],
          [action.payload.key]: action.payload.value,
        },
      };

    case "RANGE_UPDATE":
      if (action.payload.noRange === "empty") {
        let updatedState = { ...state };
        delete updatedState[action?.payload?.name];
        return {
          ...updatedState,
        };
      }

      if (action.payload.value === undefined) {
        return {
          ...state,
        };
      }

      return {
        ...state,
        [action.payload.name]: {
          ...state[action?.payload?.name],
          value: {
            ...state[action?.payload?.name]?.value,
            [action.payload.key]: action.payload.value,
          },
        },
      };

    case "CALCULATE_PERCENTAGE":
      let value = action.payload.value;
      if (action.payload.value === "on" || action.payload.value === true) {
        value = true;
        state.mandatoryTrueCount = parseInt(state.mandatoryTrueCount) + 1;
      }

      if (action.payload.value === "off" || action.payload.value === false) {
        value = false;
        state.mandatoryTrueCount = parseInt(state.mandatoryTrueCount) - 1;
      }
      return {
        ...state,
        [action.payload.name]: {
          ...state[action?.payload?.name],
          [action.payload.key]: value,
        },
      };

    case "ADDITIONAL_FIELDS":
      return {
        ...state,
        [action.payload.name]: action.payload.value,
      };

    case "CHECKBOX":
      return {
        ...state,
        [action.payload.name]: action.payload.value,
      };

    case "UPDATE_NUMBER_FIELD":
      return {
        ...state,
        [action.payload.name]: {
          ...state[action?.payload?.name],
          [action.payload.key]: action.payload.value,
        },
      };
    default:
      return state;
  }
};
